module.exports = __webpack_public_path__ + "static/open_graph_image-e0a56b2c697f78ac671c597077e54dd4.jpg";